module.exports = __webpack_public_path__ + "b460e6df447c22cc3fec732ef72d0d4c.png";